import React from 'react';
import { Form } from 'react-bootstrap';
import DashIcon from '../dash-icon'; // Assuming DashIcon is your custom icon component
import './formFields.scss';

const FormFields = ({
    name,
    label,
    type = 'text',
    value,
    onChange,
    placeholder,
    isValid,
    isInvalid,
    options = [],
    required = false,
    maxLength,
    rows = 3,
    errorMessage,
    validated,
    selectValue,
    borderColor, 
    backgroundColor,
    color,
    dashColor
}) => {
console.log("backgroundColor --",backgroundColor)
    const inputStyle = {
        '--border-color': borderColor,
        '--background-color': backgroundColor,
        '--color': color,
        '--dashColor': dashColor,
        '--imgurl': '',
      };

      const selectStyle = backgroundColor === '#1D252C' ? 'form-select-ads' : 'form-select-role';
      const selectErrorStyle = backgroundColor === '#1D252C' ? 'form-selecterror-ads' : 'form-role-error';
    const renderField = () => {
        switch (type) {
            case 'text':
            case 'email':
                return (
                    <Form.Control
                        className="form-custom-input"
                        name={name}
                        type={type}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        required={required}
                        isValid={isValid}
                        isInvalid={isInvalid}
                        maxLength={maxLength}
                        style={inputStyle}
                    />
                );
            case 'textarea':
                return (
                    <Form.Control
                        as="textarea"
                        className='multiLineBox'
                        name={name}
                        rows={rows}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        required={required}
                        isValid={isValid}
                        isInvalid={isInvalid}
                        maxLength={maxLength}
                        style={inputStyle}
                    />
                );
            case 'select':
                return (
                    <Form.Select
                        id={!isValid && validated ? selectErrorStyle : selectStyle}
                        className={selectValue ? 'custom-dropdown-select w-100' : 'custom-dropdown w-100'}
                        name={name}
                        value={value}
                        onChange={onChange}
                        required={required}
                        isValid={isValid}
                        isInvalid={isInvalid}
                        style={{
                            ...inputStyle,
                            // backgroundImage: `url(${imageUrl})`,
                        }}
                    >
                        <option value="Role">Role</option>
                        {options.map((option, index) => (
                            <option key={index} value={option}>
                                {option}
                            </option>
                        ))}
                    </Form.Select>
                );
            default:
                return null;
        }
    };

    return (
        <>
            {type === "textarea" ?
                <div>
                    <div className='d-flex' >
                        <DashIcon inputStyle={inputStyle}/>
                        <div className='text-area-container'><Form.Label className='labelStyle'  style={inputStyle}>How can we support your advertising goals?</Form.Label></div>
                    </div>
                    <div className='textarea-div'>
                        <Form.Group>
                            {renderField()}
                            <Form.Control.Feedback className="validation-text-error" type="invalid">{errorMessage}</Form.Control.Feedback>
                        </Form.Group>
                    </div>
                </div>

                : <div className="input-container">
                    <DashIcon inputStyle={inputStyle}/>
                    <div className="input-wrapper">
                        <Form.Group>
                            {renderField()}
                            <Form.Control.Feedback className="validation-text-error" type="invalid">{errorMessage}</Form.Control.Feedback>
                        </Form.Group>
                    </div>
                </div>}
        </>
    );
};

export default FormFields;
